import { Component } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
})
export class HeaderBDPComponent {
    public homeURL: string;
    public showFacilityInformation: boolean;
    public cartDisallowedRoutes: string[];

    constructor() {
        this.homeURL = 'search-awb';
        this.showFacilityInformation = false;
        this.cartDisallowedRoutes = ['cart/confirmation'];
    }
}
